<template>
	<auth-layout title="账号登录" subtitle="欢迎回来，请登录您的账号">
		<el-form class="auth-form" :model="loginForm" status-icon :rules="rules" ref="loginForm"
			@keyup.enter.native="submitForm('loginForm')">
			<el-form-item prop="userName" v-show="false">
				<el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item prop="userName">
				<el-input type="userName" v-model="loginForm.userName" autocomplete="off"
					:placeholder="loginNamePlaceholder" prefix-icon="el-icon-user" maxLength="50" clearable></el-input>
			</el-form-item>
			<el-form-item prop="password">
				<el-input type="password" v-model="loginForm.password" autocomplete="off"
					placeholder="请输入密码" prefix-icon="el-icon-lock" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<div class="form-actions">
					<el-button type="primary" :loading="loading" :disabled="loading"
						@click="submitForm('loginForm')">登 录</el-button>
					<el-button :disabled="loading" @click="resetForm('loginForm')">清 空</el-button>
				</div>
			</el-form-item>
			<div class="form-footer">
				<a :href="$store.state.configStore.app.downloadUrl" target="_blank" class="download-btn">
					<img src="@/assets/common/cdownload.png" />
					<span>App 下载</span>
				</a>
				<router-link to="/register">没有账号？立即注册</router-link>
			</div>
		</el-form>
	</auth-layout>
</template>

<script>
import AuthLayout from '@/components/common/AuthLayout.vue';

export default {
	name: "login",
	components: { AuthLayout },
	data() {
		var checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			callback();
		};
		return {
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: ''
			},
			loading: false,
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}]
			}
		};
	},
	methods: {
		submitForm(formName) {
			if (this.loading) {
				return;
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true;
					this.$http({
						url: "/login",
						method: 'post',
						data: this.loginForm
					})
						.then((data) => {
							this.setCookie('username', this.loginForm.userName);
							this.setCookie('password', this.loginForm.password);
							sessionStorage.setItem("accessToken", data.accessToken);
							sessionStorage.setItem("refreshToken", data.refreshToken);
							this.$message.success("登录成功");
							this.$router.push("/home/chat");
						})
						.finally(() => {
							this.loading = false;
						});
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		getCookie(name) {
			let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			let arr = document.cookie.match(reg)
			if (arr) {
				return unescape(arr[2]);
			}
			return '';
		},
		setCookie(name, value) {
			document.cookie = name + "=" + escape(value);
		}
	},
	mounted() {
		this.loginForm.userName = this.getCookie("username");
		this.loginForm.password = this.getCookie("password");
	},
	computed: {
		loginNamePlaceholder() {
			let mode = this.$store.state.configStore.registration.mode || [];
			let strText = "用户名";
			if (mode.includes("phone")) {
				strText += "/手机号"
			}
			if (mode.includes("email")) {
				strText += "/邮箱"
			}
			return `请输入${strText}`;
		}
	}
}
</script>

<style scoped lang="scss">
@import '@/assets/style/auth-form.scss';
</style>
